import {AdaptiveCardWrapper, Colors, FlexBox} from "@brg/ui";
import React, {FC, ReactElement, ReactNode, useCallback, useMemo} from "react";
import {ProjectCardContainerNew} from "../../components/projectCard/stylesNew";
import styled, {css} from "styled-components";
import {LayoutConst} from "../../../core";
import {API, Card, Endpoints, TFile} from "@brg/api";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {useTranslation} from "react-i18next";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import {getCurrentAppName, getCurrentContextName} from "../../../supporting";
import {getCardNumber} from "../../helpers/utils/getCardNumber";
import { LikesBox } from "shared/components/likesBox";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import PrivateCollectionIcon from "./PrivateCollectionIcon";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? FlexBox : require('adaptive-cards');

const OverflowContainer = styled.div<{selected?: boolean, isSold?: boolean}>`
  overflow: hidden;
  width: fit-content;
  height: fit-content;
  position: relative;

  border: 2px solid ${({selected}) => selected ? '#146DEE' : 'transparent'};
  cursor: ${({isSold}) => isSold ? "auto" : "pointer"};
`

const SmallCardContainer = styled.div`
  width: 123px;
  height: 173px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 166px;
    height: 234px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: calc((50vw - 15px) * 1.407);
    width: calc(50vw - 15px);
  }
`

const BigCardContainer = styled.div`
`

const ShopLikesWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  justify-content: end;
  align-items: end;
  padding: 16px;
  background: linear-gradient(180deg,rgba(21,20,20,0) 0%,rgba(21,21,20,0.6) 100%);
`

export const ShopImage = styled.div<{isSmall?: boolean, whiteBg?: boolean, isModalGood?: boolean, isCalendarImage?: boolean }>`
  display: flex;
  flex-grow: 1;
  background: ${p => p.whiteBg ? Colors.gal : "rgba(34, 34, 34, 0.06)"};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  align-items: center;
  justify-content: center;

  position: relative;

  &:hover {
    ${ShopLikesWrapper} {
      display: flex;
    }
  }
  
  height: ${LayoutConst.projectCard.l.h}px;
  min-height: ${LayoutConst.projectCard.l.h}px;
  max-height: ${LayoutConst.projectCard.l.h}px;
  width: ${LayoutConst.projectCard.l.w}px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: ${LayoutConst.projectCard.l.h}px;
    min-height: ${LayoutConst.projectCard.l.h}px;
    max-height: ${LayoutConst.projectCard.l.h}px;
    width: ${LayoutConst.projectCard.l.w}px;
  }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    min-height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    max-height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    width: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.w : LayoutConst.projectCard.s.w}px;
  }
  
  @media (max-width: ${(LayoutConst.screen.s - 1) + 'px'}) {
    height: calc((50vw - 15px) * 1.407);
    max-height: calc((50vw - 15px) * 1.407);
    width: calc(50vw - 15px);
    min-height: calc((50vw - 15px) * 1.407);
  }
  
  img {
    object-fit: contain;
    object-position: top center;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
  
  ${({isSmall}) => isSmall && css`
    width: 123px;
    height: 173px;
    min-height: 173px;
    max-height: 173px;
    position: relative;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 166px;
      height: 234px;
      min-height: 234px;
      max-height: 234px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      height: calc((50vw - 15px) * 1.407);
      min-height: calc((50vw - 15px) * 1.407);
      max-height: calc((50vw - 15px) * 1.407);
      width: calc(50vw - 15px);
    }
  `}

  ${({isCalendarImage}) => isCalendarImage && css`
    max-height: none !important;
    height: auto !important;
  `}
`
const ShopTitle = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

const ShopPrice = styled.div<{ isBook?: boolean }>`
  color: ${Colors.galBlack100};
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; 
  letter-spacing: -0.44px;

  ${({ isBook }) => isBook && css`
    flex-flow: row;
    display: flex;
    place-items: center;
    div {
      margin: 0;
    }
  `};
`

const SubsOnly = styled.div`
  color: #545453;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  border-bottom: 1px solid #545453;
`

const AdditionalMarks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0 auto auto 0;
`

const AdditionalMark = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  background: rgba(24, 26, 28, 0.45);
  backdrop-filter: blur(2px);
  color: #FFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  width: fit-content;
`

const UsedInProjectBlock = styled.div`
  display: flex;
  color: #FFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  width: 100%;
  flex-direction: column;
  gap: 2px;
`


interface ShopCardProps {
    card?: Card
    selected?: boolean;
    isSmall?: boolean;
    isSold?: boolean;
    id?: string;
    images?: TFile[];
    name?: string
    price?: number
    customClick?: () => void
    outOfStockComponent?: ReactElement | null
    isBook?: boolean;
    isModalGood?: boolean
    useTemplateCard?: boolean
    hidePrice?: boolean
    priceOnRequest?: boolean
    project?: any,
    selectedComponent: ReactNode,
    isCalendarImage?: boolean,
    usedInProjectName?: string;
    isPrivateCollection? : boolean
}

export const ShopCard: FC<ShopCardProps> = (props) => {

    const {
        project,
        card: cardSrc,
        selected,
        isSmall,
        id = "",
        images = [],
        name = "",
        price = 0,
        customClick,
        isSold,
        outOfStockComponent,
        isBook,
        isModalGood,
        useTemplateCard,
        selectedComponent,
        hidePrice,
        priceOnRequest,
        isCalendarImage,
        usedInProjectName,
        isPrivateCollection
    } = props

    const {i18n, t} = useTranslation();
    const [image, ref] = useResizedImageEnhanced(images);
    const appName = getCurrentAppName()
    const contextName = getCurrentContextName()
    const history = useHistory()

    const card = useMemo(() => {

        const cardLang: any = API.toLang(cardSrc, i18n.language)
        const title: string = cardLang?.templateData?.title || cardLang?.templateType?.name
        const link: string = cardLang?.templateData?.link || "gallllery.com"
        const cardNumber = getCardNumber(cardLang?.sequenceItem?.number)

        const getTemplateType = () => {
            return cardSrc?.templateType?.nameComponent || 
                   cardLang?.templateData?.typeTemplate || 
                   null;
        };

        return {
            ...cardSrc,
            number: cardNumber,
            templateData: {
                //@ts-ignore
                ...cardSrc?.templateData,
                title,
                link,
            },
            templateType: {
                //@ts-ignore
                ...cardSrc?.templateType,
                nameComponent: getTemplateType(),
                orientation: "vertical",
            }
        }
    }, [i18n.language, cardSrc]);

    // @ts-ignore
    const isSoldOut = isSold || card?.count === 0;
    const cardName = useMemo(() => isBook || isModalGood 
        ? name 
        : translateStrangeObject(name, i18n.language), [id, name, i18n.language, isBook])
    const cardImage = useMemo(() => {
        const selectedImage = image || images?.[0];
        return selectedImage?.url ? `${Endpoints.files}/${selectedImage.url}` : null;
    }, [image, images])

    const computePrice = useMemo(() => {
      if (isBook) {
        const p = String(price)?.split('.');
        const isFloat = p?.length === 2;

        return isFloat ? (Number(p?.[1]) > 0 ? price : Math.trunc(price)) : price;
      }
      return price;
    } , [price, isBook])

      const onCardClick = useCallback(() => {
        if (customClick) {
            customClick();
            return;
        }
        window.open(process.env.REACT_APP_URL_SHOP_BRANDS + '/card/' + id, "_blank")
    }, [customClick, id])

    if (useTemplateCard) {
        return (
            <OverflowContainer>
                <ShopImage whiteBg onClick={onCardClick}>
                    {card?.templateType?.nameComponent ? (
                        <AdaptiveCardWrapper
                            cardProps={{
                                data: API.lang(card, i18n.language),
                                templateType: card?.templateType?.nameComponent,
                                appName,
                                contextName,
                            }}
                            Endpoints={Endpoints}
                            images={images}
                        >
                            <CardComponent.MasterCard/>
                        </AdaptiveCardWrapper>
                    ) : (
                        cardImage && <img src={cardImage} alt=""/>
                    )}
                </ShopImage>
                {cardName && <FlexBox offsetTop={12}><ShopTitle>{cardName}</ShopTitle></FlexBox>}
                <FlexBox offsetTop={cardName ? 4 : 12}>
                    {isSoldOut ? (outOfStockComponent || "Товар закончился") : 
                     <ShopPrice isBook={isBook}>{computePrice}&nbsp;{isBook ? <FlorinIcon size={1.3}/> : '₽'}</ShopPrice>}
                </FlexBox>
            </OverflowContainer>
        );
    }

    return (<OverflowContainer isSold={isSold} {...(!selectedComponent && {selected: selected })} ref={ref} onClick={onCardClick} className="card-item">

            {selectedComponent && selectedComponent}
            <ShopImage isCalendarImage={isCalendarImage} isSmall={isSmall} isModalGood={isModalGood}>
              {cardImage && <img src={cardImage} alt=""/>}
              <ShopLikesWrapper>
                {isPrivateCollection && <PrivateCollectionIcon />}
                {!isCalendarImage && <LikesBox likes={project?.quCount ?? 0} />}
                {usedInProjectName && <UsedInProjectBlock>Используется в <b>{usedInProjectName}</b></UsedInProjectBlock>}
              </ShopLikesWrapper>
            </ShopImage>
            {cardName && <FlexBox offsetTop={12}><ShopTitle>{cardName}</ShopTitle></FlexBox>}
            {!hidePrice && (
              <FlexBox offsetTop={cardName ? 4 : 12}>
                { 
                isSoldOut ? (outOfStockComponent || "Товар закончился") : 
                priceOnRequest ? t('shop.price_on_request') :
                project?.distributionTypes?.includes(1)?
                <SubsOnly>{t('shop.on_subscribe')}</SubsOnly> :
                <ShopPrice isBook={isBook}>
                  {computePrice}&nbsp;{'₽'}
                </ShopPrice>
                }
              </FlexBox>
            )}
        </OverflowContainer>)
}import {AdaptiveCardWrapper, Colors, FlexBox} from "@brg/ui";
import React, {FC, ReactElement, ReactNode, useCallback, useMemo} from "react";
import {ProjectCardContainerNew} from "../../components/projectCard/stylesNew";
import styled, {css} from "styled-components";
import {LayoutConst} from "../../../core";
import {API, Card, Endpoints, TFile} from "@brg/api";
import {translateStrangeObject} from "../../helpers/translateStrangeObject";
import {useTranslation} from "react-i18next";
import {useResizedImageEnhanced} from "../../hooks/useResizedImageEnhanced";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import {getCurrentAppName, getCurrentContextName} from "../../../supporting";
import {getCardNumber} from "../../helpers/utils/getCardNumber";
import { LikesBox } from "shared/components/likesBox";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import PrivateCollectionIcon from "./PrivateCollectionIcon";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? FlexBox : require('adaptive-cards');

const OverflowContainer = styled.div<{selected?: boolean, isSold?: boolean}>`
  overflow: hidden;
  width: fit-content;
  height: fit-content;
  position: relative;

  border: 2px solid ${({selected}) => selected ? '#146DEE' : 'transparent'};
  cursor: ${({isSold}) => isSold ? "auto" : "pointer"};
`

const SmallCardContainer = styled.div`
  width: 123px;
  height: 173px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 166px;
    height: 234px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: calc((50vw - 15px) * 1.407);
    width: calc(50vw - 15px);
  }
`

const BigCardContainer = styled.div`
`

const ShopLikesWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  justify-content: end;
  align-items: end;
  padding: 16px;
  background: linear-gradient(180deg,rgba(21,20,20,0) 0%,rgba(21,21,20,0.6) 100%);
`

export const ShopImage = styled.div<{isSmall?: boolean, whiteBg?: boolean, isModalGood?: boolean, isCalendarImage?: boolean }>`
  display: flex;
  flex-grow: 1;
  background: ${p => p.whiteBg ? Colors.gal : "rgba(34, 34, 34, 0.06)"};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  align-items: center;
  justify-content: center;

  position: relative;

  &:hover {
    ${ShopLikesWrapper} {
      display: flex;
    }
  }
  
  height: ${LayoutConst.projectCard.l.h}px;
  min-height: ${LayoutConst.projectCard.l.h}px;
  max-height: ${LayoutConst.projectCard.l.h}px;
  width: ${LayoutConst.projectCard.l.w}px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: ${LayoutConst.projectCard.l.h}px;
    min-height: ${LayoutConst.projectCard.l.h}px;
    max-height: ${LayoutConst.projectCard.l.h}px;
    width: ${LayoutConst.projectCard.l.w}px;
  }

  @media (max-width: ${LayoutConst.screen.l + 'px'}) {
    height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    min-height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    max-height: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.h: LayoutConst.projectCard.s.h}px;
    width: ${({isModalGood}) => isModalGood ? LayoutConst.projectCard.xs.w : LayoutConst.projectCard.s.w}px;
  }
  
  @media (max-width: ${(LayoutConst.screen.s - 1) + 'px'}) {
    height: calc((50vw - 15px) * 1.407);
    max-height: calc((50vw - 15px) * 1.407);
    width: calc(50vw - 15px);
    min-height: calc((50vw - 15px) * 1.407);
  }
  
  img {
    object-fit: contain;
    object-position: top center;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
  
  ${({isSmall}) => isSmall && css`
    width: 123px;
    height: 173px;
    min-height: 173px;
    max-height: 173px;
    position: relative;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 166px;
      height: 234px;
      min-height: 234px;
      max-height: 234px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      height: calc((50vw - 15px) * 1.407);
      min-height: calc((50vw - 15px) * 1.407);
      max-height: calc((50vw - 15px) * 1.407);
      width: calc(50vw - 15px);
    }
  `}

  ${({isCalendarImage}) => isCalendarImage && css`
    max-height: none !important;
    height: auto !important;
  `}
`
const ShopTitle = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

const ShopPrice = styled.div<{ isBook?: boolean }>`
  color: ${Colors.galBlack100};
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; 
  letter-spacing: -0.44px;

  ${({ isBook }) => isBook && css`
    flex-flow: row;
    display: flex;
    place-items: center;
    div {
      margin: 0;
    }
  `};
`

const SubsOnly = styled.div`
  color: #545453;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  border-bottom: 1px solid #545453;
`

const AdditionalMarks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0 auto auto 0;
`

const AdditionalMark = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  background: rgba(24, 26, 28, 0.45);
  backdrop-filter: blur(2px);
  color: #FFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  width: fit-content;
`

const UsedInProjectBlock = styled.div`
  display: flex;
  color: #FFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  width: 100%;
  flex-direction: column;
  gap: 2px;
`


interface ShopCardProps {
    card?: Card
    selected?: boolean;
    isSmall?: boolean;
    isSold?: boolean;
    id?: string;
    images?: TFile[];
    name?: string
    price?: number
    customClick?: () => void
    outOfStockComponent?: ReactElement | null
    isBook?: boolean;
    isModalGood?: boolean
    useTemplateCard?: boolean
    hidePrice?: boolean
    priceOnRequest?: boolean
    project?: any,
    selectedComponent: ReactNode,
    isCalendarImage?: boolean,
    usedInProjectName?: string;
    isPrivateCollection? : boolean
}

export const ShopCard: FC<ShopCardProps> = (props) => {

    const {
        project,
        card: cardSrc,
        selected,
        isSmall,
        id = "",
        images = [],
        name = "",
        price = 0,
        customClick,
        isSold,
        outOfStockComponent,
        isBook,
        isModalGood,
        useTemplateCard,
        selectedComponent,
        hidePrice,
        priceOnRequest,
        isCalendarImage,
        usedInProjectName,
        isPrivateCollection
    } = props

    const {i18n, t} = useTranslation();
    const [image, ref] = useResizedImageEnhanced(images);
    const appName = getCurrentAppName()
    const contextName = getCurrentContextName()
    const history = useHistory()

    const card = useMemo(() => {

        const cardLang: any = API.toLang(cardSrc, i18n.language)
        const title: string = cardLang?.templateData?.title || cardLang?.templateType?.name
        const link: string = cardLang?.templateData?.link || "gallllery.com"
        const cardNumber = getCardNumber(cardLang?.sequenceItem?.number)

        const getTemplateType = () => {
            return cardSrc?.templateType?.nameComponent || 
                   cardLang?.templateData?.typeTemplate || 
                   null;
        };

        return {
            ...cardSrc,
            number: cardNumber,
            templateData: {
                //@ts-ignore
                ...cardSrc?.templateData,
                title,
                link,
            },
            templateType: {
                //@ts-ignore
                ...cardSrc?.templateType,
                nameComponent: getTemplateType(),
                orientation: "vertical",
            }
        }
    }, [i18n.language, cardSrc]);

    // @ts-ignore
    const isSoldOut = isSold || card?.count === 0;
    const cardName = useMemo(() => isBook || isModalGood 
        ? name 
        : translateStrangeObject(name, i18n.language), [id, name, i18n.language, isBook])
    const cardImage = useMemo(() => {
        const selectedImage = image || images?.[0];
        return selectedImage?.url ? `${Endpoints.files}/${selectedImage.url}` : null;
    }, [image, images])

    const computePrice = useMemo(() => {
      if (isBook) {
        const p = String(price)?.split('.');
        const isFloat = p?.length === 2;

        return isFloat ? (Number(p?.[1]) > 0 ? price : Math.trunc(price)) : price;
      }
      return price;
    } , [price, isBook])

      const onCardClick = useCallback(() => {
        if (customClick) {
            customClick();
            return;
        }
        window.open(process.env.REACT_APP_URL_SHOP_BRANDS + '/card/' + id, "_blank")
    }, [customClick, id])

    if (useTemplateCard) {
        return (
            <OverflowContainer>
                <ShopImage whiteBg onClick={onCardClick}>
                    {card?.templateType?.nameComponent ? (
                        <AdaptiveCardWrapper
                            cardProps={{
                                data: API.lang(card, i18n.language),
                                templateType: card?.templateType?.nameComponent,
                                appName,
                                contextName,
                            }}
                            Endpoints={Endpoints}
                            images={images}
                        >
                            <CardComponent.MasterCard/>
                        </AdaptiveCardWrapper>
                    ) : (
                        cardImage && <img src={cardImage} alt=""/>
                    )}
                </ShopImage>
                {cardName && <FlexBox offsetTop={12}><ShopTitle>{cardName}</ShopTitle></FlexBox>}
                <FlexBox offsetTop={cardName ? 4 : 12}>
                    {isSoldOut ? (outOfStockComponent || "Товар закончился") : 
                     <ShopPrice isBook={isBook}>{computePrice}&nbsp;{isBook ? <FlorinIcon size={1.3}/> : '₽'}</ShopPrice>}
                </FlexBox>
            </OverflowContainer>
        );
    }

    return (<OverflowContainer isSold={isSold} {...(!selectedComponent && {selected: selected })} ref={ref} onClick={onCardClick} className="card-item">

            {selectedComponent && selectedComponent}
            <ShopImage isCalendarImage={isCalendarImage} isSmall={isSmall} isModalGood={isModalGood}>
              {cardImage && <img src={cardImage} alt=""/>}
              <ShopLikesWrapper>
                {isPrivateCollection && <PrivateCollectionIcon />}
                {!isCalendarImage && <LikesBox likes={project?.quCount ?? 0} />}
                {usedInProjectName && <UsedInProjectBlock>Используется в <b>{usedInProjectName}</b></UsedInProjectBlock>}
              </ShopLikesWrapper>
            </ShopImage>
            {cardName && <FlexBox offsetTop={12}><ShopTitle>{cardName}</ShopTitle></FlexBox>}
            {!hidePrice && (
              <FlexBox offsetTop={cardName ? 4 : 12}>
                { 
                isSoldOut ? (outOfStockComponent || "Товар закончился") : 
                priceOnRequest ? t('shop.price_on_request') :
                project?.distributionTypes?.includes(1)?
                <SubsOnly>{t('shop.on_subscribe')}</SubsOnly> :
                <ShopPrice isBook={isBook}>
                  {computePrice}&nbsp;{'₽'}
                </ShopPrice>
                }
              </FlexBox>
            )}
        </OverflowContainer>)
}